import React from 'react';
import { useFieldArray, UseFieldArrayReturn } from 'react-hook-form';
import styles from '../../../DataExtractionTemplate.module.scss';
import { DataExtractionTemplateState } from '../../../DataExtractionTemplate';
import EditableField from '../../EditableField';
import {
  validate,
  NO_EQUIVALENT_VALUE,
} from '../../../../components/editableFieldValidation';
import ResultDataPopoverText from '../ResultDataPopoverText';
import { standardMeasureLabels } from '../../ResultsDataPanel/ResultDataFormats';
import { LabelErrorMessages } from '../../../../components/editableFieldValidation';
import { Heading, Icon, IconList, Link } from 'components/core';

const ConsolidatedMeasures = ({
  showHeader,
  fullWidth,
}: {
  showHeader?: boolean;
  fullWidth?: boolean;
}) => {
  const MAX_LENGTH = 255;
  const consolidatedMeasures = useFieldArray<DataExtractionTemplateState>({
    name: 'consolidated_measures',
  }) as UseFieldArrayReturn<
    DataExtractionTemplateState,
    'consolidated_measures'
  >;

  const customErrorMessages = {
    ...LabelErrorMessages,
    restrictedValueError:
      'Already included in common data formats. Please enter a unique label.',
  };

  const handleAppend = async () => {
    consolidatedMeasures.append({
      label: '',
      used: false,
      custom_result_types: [],
    });
  };

  return (
    <div className={styles.details}>
      {showHeader && (
        <>
          <Heading type="h5" component="h4" variant="neutral">
            Result data
          </Heading>
          <ResultDataPopoverText weak />
        </>
      )}

      {consolidatedMeasures.fields.map((field, index) => (
        <EditableField
          key={field.id}
          index={index}
          attribute="label"
          canDelete={!field.used}
          name={`consolidated_measures`}
          fullWidth={fullWidth}
          onDelete={() => consolidatedMeasures.remove(index)} // Delete should be disabled if used is true
          validate={(value, existingFields) => {
            return validate(
              value,
              existingFields,
              standardMeasureLabels,
              NO_EQUIVALENT_VALUE,
              MAX_LENGTH,
              customErrorMessages
            );
          }}
        />
      ))}

      <Link
        onClick={handleAppend}
        variant="primary"
        className={styles.AddButton}
      >
        <Icon icon={IconList.light.faPlus} /> Add custom
      </Link>
    </div>
  );
};
export default ConsolidatedMeasures;
